/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
export var StyledTableLoading = styled('div')(function () {
  return {
    '&.EmbersTableLoading-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 235,
      width: '100%'
    }
  };
});